import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { useAbortablePromise } from '..';
import { getDowntimeStatus } from '../../../api/downtime';
import { getPrioritizedStatus, processStatuses, Status } from './helper';

type DowntimeConfig = {
  essentialServices: string[];
};

const useDowntime = (): Status | undefined => {
  const [{ data }] = useAbortablePromise(async signal => {
    return getDowntimeStatus({ signal });
  }, []);

  const { getText } = useTranslations();

  if (!data) {
    return undefined;
  }

  const config = getText('downtime') as unknown as DowntimeConfig | string;
  const essentialServices =
    typeof config === 'object' ? config.essentialServices : [];

  const processedStatuses = processStatuses(data, essentialServices);
  return getPrioritizedStatus(processedStatuses);
};

export default useDowntime;
